const privacyPerRouter = {
  path: '/member',
  name: 'Member',
  redirect: '/Member/order',
  component: () => import('@/layout/memberHeader'),
  children: [
    {
      path: 'order',
      name: 'Order',
      redirect: 'order/privacy',
      component: () => import(/* webpackChunkName: "privacy" */ '@/pages/member'),
      children: [
        {
          path: 'privacy',
          name: 'Privacy',
          meta: { title: '私密商品' },
          component: () => import(/* webpackChunkName: "privacy" */ '@/pages/member/privacy')
        }
      ]
    }
  ]
}

export default privacyPerRouter
